import { render, staticRenderFns } from "./IndicatorPlugin.vue?vue&type=template&id=4908afe2&scoped=true"
import script from "./IndicatorPlugin.vue?vue&type=script&lang=js"
export * from "./IndicatorPlugin.vue?vue&type=script&lang=js"
import style0 from "./IndicatorPlugin.vue?vue&type=style&index=0&id=4908afe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4908afe2",
  null
  
)

export default component.exports